import React from 'react';
import classNames from 'classnames';
import MainNavbarContext from '../main-navbar-context';
import ApplicationNavbarContext from '../application-navbar-context';

export default function SubNav() {
  const { state, dispatch } = React.useContext(ApplicationNavbarContext);
  const { state: mainNavbarState } = React.useContext(MainNavbarContext);
  const [menus, setMenus] = React.useState([]);

  React.useEffect(() => {
    if (state.activeExpandableMenu) {
      const sourceMenu = mainNavbarState[state.activeExpandableMenu] || [];
      setMenus(sourceMenu);
    } else {
      dispatch({ type: 'hideSubNav' });
    }
  }, [state.activeExpandableMenu, mainNavbarState, dispatch]);

  function createOnMouseEnter(name) {
    return () => {
      if (state.subNavHoverTimeout) {
        clearTimeout(state.subNavHoverTimeout);
      }
      dispatch({
        type: 'setSubNavHoverTimeout',
        payload: setTimeout(() => dispatch({ type: 'showPreviewNav', payload: name }), 500),
      });
    };
  }

  function onMouseLeave() {
    if (state.subNavHoverTimeout) {
      clearTimeout(state.subNavHoverTimeout);
      dispatch({ type: 'setSubNavHoverTimeout', payload: null });
    }
  }

  return (
    <div className={classNames('application-navbar-sub-navigation', {
      hidden: !state.isSubNavVisible,
    })}
    >
      <ul>
        {menus.map(({ name, url }) => (
          <li
            className={classNames('sub-menu', { active: name === state.activeSubMenu })}
            onMouseLeave={onMouseLeave}
            onMouseEnter={createOnMouseEnter(name)}
            key={name}
          >
            <a href={url}>
              <span>{name}</span>
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
}
